import React from 'react'
import "../css/latest-button.css"
import { motion, useTransform } from 'framer-motion';

const LatestButton = ({ smart, opacity, scrollY,  windowWidth }) => {


  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { duration: 0.7, delay: 3 } }} className="wrapper" style={{ mixBlendMode: 'normal' }}>
        <motion.div className="latest-button-container">
            <div className="latest-button-grid">
                {/* <div className='play-button'>
                    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <polygon points="0,20 10,5 10,15 20,0" fill='white' />
                    </svg>
                </div> */}
                <a style={{ textDecoration: "none" }} href={smart} target="_blank" className='latest-release-text'>
                    <motion.div animate={ windowWidth > 700 ? { x: -118 } : { x: -104 } } transition={{ duration: 5, repeat: Infinity, ease: "linear" }} className="latest-release-marquee">LATEST RELEASE &nbsp;&nbsp;&nbsp;&nbsp; LATEST RELEASE &nbsp;&nbsp;&nbsp;&nbsp; LATEST RELEASE &nbsp;&nbsp;&nbsp;&nbsp; LATEST RELEASE &nbsp;&nbsp;&nbsp;&nbsp; LATEST RELEASE</motion.div>
                </a>
            </div>
        </motion.div>
    </motion.div>
  )
}

export default LatestButton